<template>
    <div class="">
        <Vue100vh id="teste-id" class="component-container d-flex flex-column justify-space-between ">
            <div>

                <appbar-client @clickAddress='openAddress' />
                <dialog-address @changeSearchMethod='changeSearchMethod' @changeAddressCoords='addressCoords = $event' />

            </div>

            <v-expand-x-transition>

                <v-container>
                    <v-row>
                        <v-col>
                            <v-btn rounded class="pointer-events btn-search-magnify mb-4" block :class="!isMobile ? 'ml-2' : null" :loading="loading" color="#4ec5c1" @click="onNextClick" v-if="hasCoord">
                                <v-icon class="" color='black'>mdi-magnify</v-icon>
                                <span class='black--text font-weight-medium ' v-html="$t('search_providers')"></span>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>

            </v-expand-x-transition>

            <v-btn class="pointer-events btn-search btn-loc" small fab right absolute bottom color="#4ec5c1" @click="askPosition" :loading="loading" v-if="hasCoord">
                <v-icon color="black">mdi-crosshairs-gps</v-icon>
            </v-btn>

            <v-btn v-if="!hasCoord" class="pointer-events btn-loc" fab right absolute bottom :class="pulseBtn ? 'btn-search-gps' : null" :loading="loading" :color="pulseBtn ? 'warning' : 'primary'" dark @click="askPosition">
                <v-icon>mdi-crosshairs-gps</v-icon>
            </v-btn>

        </Vue100vh>

        <overlay-client :getLocalInit="getLocalInit" :showDialog="showDialog" />

    </div>
</template>

<script>

import { mapActions, mapGetters, mapMutations } from 'vuex'
import { ADDRESS_SELECTED, PROSPECT_SHOW, INIT_PROSPECT, CHANGE_COORD, SET_GPS_ORIGINAL_LOCATION, BACK_TO_GPS } from '../../store/mutations';
import PlacesService from '../../services/Places';
import { ROUTE_PROSPECT_FORM, ROUTE_PROVIDERS_LIST } from '../../router/routes';
import { osName, mobileModel, osVersion, browserVersion, browserName } from 'mobile-device-detect';

const AppbarClient = () => import('../components/prospectClient/AppbarClient.vue');
const OverlayClient = () => import('../components/prospectClient/OverlayClient.vue');
const DialogAddress = () => import('../components/prospectClient/DialogAddress.vue');

export default {
  components: { AppbarClient, OverlayClient, DialogAddress },
    name: 'Client',
    data() {
        return {
            firstGps: false,
            searchMethod: 'Gps',
            addressCoords: {},
            pulseBtn: true,
            loading: false,
            service: null,
            showAddressList: false,
            showDialog: true,
            options: {
                enableHighAccuracy: true,
                timeout: 600,
            }
        };
    },

    computed: {

        ...mapGetters({
            prospect: `ProspectVuex/prospect`,
            checkMap: 'map',
            getLocalInit: 'local_init',
            hasCoord: 'ProspectVuex/prospect_has_coordinates',
            gpsOriginalLocation: 'ProspectVuex/gpsOriginalLocation',
        }),

    },

    created() {
        
    },

    watch: {

        async checkMap(newMap) {

            this.unsetCoords();

            this.service = new PlacesService(newMap);

            const position = await this.$getLocation(this.options)

            await this.initProspect({ locale: localStorage.locale })

            if (position) {

                if (!this.gpsOriginalLocation.coordinates) this.setFirstGps({ coordinates: { lat: position.lat, lng: position.lng } })

                await this.addressSelected({ coordinates: { lat: position.lat, lng: position.lng }, gps_precision: position.accuracy });

                this.showToast(this.$t('prospect_location.toast_msg'), this.$t('prospect_location.toast_title'), 'info', {
                    position: 'center',
                    color: "#FF8C00",
                    class: 'alert',
                    icon: 'icon mdi mdi-map-marker-radius-outline',

                })

                document.querySelector('.alert').style.margin = '120px 0 0 0'

            }
        }
    },
    methods: {

        async isGeoAvailable() {

            try {

                await getPosition();

                return true

            } catch (err) {

                return false;

            }

            function getPosition() {

                return new Promise((resolve, reject) =>

                    navigator.geolocation.getCurrentPosition(resolve, reject)

                );
            }
        },

        ...mapActions({
            addressSelected: `ProspectVuex/${ADDRESS_SELECTED}`,
            initProspect: `ProspectVuex/${INIT_PROSPECT}`,
            unsetCoords: `ProspectVuex/${CHANGE_COORD}`,
            showProspect: `ProspectVuex/${PROSPECT_SHOW}`,
            backGps: `ProspectVuex/${BACK_TO_GPS}`,
        }),

        ...mapMutations({ setFirstGps: `ProspectVuex/${SET_GPS_ORIGINAL_LOCATION}` }),

        async askPosition() {

            if (this.gpsOriginalLocation.coordinates) {

                this.search_method = 'Gps'

                return await this.backGps(this.gpsOriginalLocation)

            }

            if (!this.prospect) await this.initProspect({ locale: localStorage.locale })

            const position = await this.$getLocation(this.options).catch((err) => {

                this.showToast(this.$t('prospect_location.toast_msg_error_gps'), this.$t('prospect_location.toast_title_error_gps'), 'warning')

                this.pulseBtn = false

                return console.log(err)


            })

            if (position) {

                if (!this.gpsOriginalLocation.coordinates) this.setFirstGps({ coordinates: { lat: position.lat, lng: position.lng } })

                this.firstGps = true

                await this.addressSelected({ coordinates: { lat: position.lat, lng: position.lng }, gps_precision: position.accuracy, status: 'Searched' });

                this.showToast(this.$t('prospect_location.toast_msg'), this.$t('prospect_location.toast_title'), 'info', {
                    position: 'center',
                    color: "#FF8C00",
                    class: 'alert',
                    icon: 'icon mdi mdi-map-marker-radius-outline',

                })

                return document.querySelector('.alert').style.margin = '120px 0 0 0'

            }

            return

        },

        openAddress() {

            this.showAddressList = true;

            this.showDialog = false;

        },

        changeSearchMethod(event) {

            console.log(event)

            this.searchMethod = event


        },

        checkSearchMethod() {

            const center = this.checkMap.getCenter()

            if (this.searchMethod === 'Gps' && this.gpsOriginalLocation?.coordinates?.lat !== center.lat() && this.gpsOriginalLocation?.coordinates?.lat !== center.lng()) return 'Manual'

            if (this.searchMethod === 'Address' && this.addressCoords.lat !== center.lat() && this.addressCoords.lat !== center.lng()) return 'Manual'

            return this.searchMethod

        },

        async onNextClick() {

            this.loading = true

            let loader = this.$loading.show({ 'is-full-page': true, color: 'green' });

            const center = this.checkMap.getCenter();

            const createService = new PlacesService(this.map)

            const geocode = await createService.geoCoding(center)

            const { address } = await createService.getPlaceDetails(geocode)

            const device_info = { 
                mobile: this.isMobile, 
                browser_name: browserName, 
                browser_version: browserVersion, 
                os: osName, 
                os_version: osVersion, 
                model: mobileModel,
                resolution: `y: ${screen.height} x: ${screen.width}`
            }

            const gps_precision = this.prospect.viability[0].gps_precision

            await this.addressSelected({
                searched_address: address,
                device_info,
                coordinates: { lat: center.lat(), lng: center.lng() },
                search_method: this.checkSearchMethod(),
                status: 'Scanned',
                gps_precision
            });

            this.showToast(this.$t('prospect_location.toast_srch_msg'), this.$t('prospect_location.toast_srch_title'), 'info', {
                position: "center",
                timeout: 60000,
                class: 'toast',
                close: false,
                icon: 'icon mdi mdi-access-point',

            })

            const toast = document.querySelector('.toast')

            try {

                const viabilityTry = await this.showProspect()

                if (viabilityTry) return this.$router.push(ROUTE_PROVIDERS_LIST)

                if (!viabilityTry) return this.$router.push(ROUTE_PROSPECT_FORM)


            } catch (error) {

                console.log(error)

                this.showToast(this.$t('prospect_location.toast_error_msg'), this.$t('prospect_location.toast_error_title'), 'error')


            } finally {

                toast.remove()
                this.loading = false
                loader.hide()

            }
        },
    },
};
</script>

<style scoped>
    .component-container {
        position: absolute;
        z-index: 10;
        width: 100%;
        pointer-events: none;
    }

    .address-container {
        margin-top: 1em;
    }

    .btn-loc {
        margin-bottom: 10em;
    }

    .address-field {
        width: 90%;
    }

    .pointer-events {
        pointer-events: all;
    }

    .button-container {
        padding: 1em;
    }

    .back-btn {
        margin: 1em;
    }

    .btn-search-gps {

        -webkit-animation: pulse-anim 2s infinite;

    }
    .btn-search-magnify {

        -webkit-animation: pulse-anim-alt 2s infinite;

    }

    .btn-search {
        color: aquamarine;
    }

    .btn-help {

        z-index: 9999;

    }



</style>
